import React, { Suspense } from 'react'

import { useFirebaseAuth } from './auth/useFirebaseAuth'
import { Game } from './Game/Game'
import { Lobby } from './Lobby'

// Lazy-loaded so the heavy charting bundle (recharts) is fetched only when the
// hidden analytics route is opened, not on every app start.
const StatsPage = React.lazy(() =>
  import('./Stats/StatsPage').then((m) => ({ default: m.StatsPage })),
)

export function Router() {
  const { user, loading, errors, signInWithGoogle } = useFirebaseAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  const searchParams = new URLSearchParams(document.location.search)
  const page = searchParams.get('page')
  const gameId = searchParams.get('gameId')

  if (page === 'stats' && user) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <StatsPage user={user} />
      </Suspense>
    )
  }

  if (!gameId || !user) {
    return (
      <Lobby
        user={user}
        loading={loading}
        errors={errors}
        signInWithGoogle={signInWithGoogle}
      />
    )
  }

  return <Game gameId={gameId} user={user} />
}
